(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artwork_detail"]) return;
  try {
    
  document.querySelectorAll('[data-rv-artwork-gallery]').forEach((gallery) => {
    const items = Array.from(gallery.querySelectorAll('[data-rv-gallery-item]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-rv-gallery-thumb]'));
    const prev = gallery.querySelector('[data-rv-gallery-prev]');
    const next = gallery.querySelector('[data-rv-gallery-next]');

    if (items.length <= 1) {
      return;
    }

    let activeIndex = 0;

    const setActive = (index) => {
      activeIndex = (index + items.length) % items.length;

      items.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === activeIndex);
      });

      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.addEventListener('click', () => {
        setActive(thumbIndex);
      });
    });

    if (prev) {
      prev.addEventListener('click', () => {
        setActive(activeIndex - 1);
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        setActive(activeIndex + 1);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["auction"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-rv-auction-section]');
    if (!sections.length) {
      return;
    }

    const storageKey = 'rv-auction-last-form';
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setStoredFormKind = (sectionId, kind) => {
      try {
        window.sessionStorage.setItem(storageKey, JSON.stringify({ sectionId, kind }));
      } catch (error) {
      }
    };

    const getStoredFormKind = () => {
      try {
        const stored = window.sessionStorage.getItem(storageKey);
        if (!stored) {
          return null;
        }
        return JSON.parse(stored);
      } catch (error) {
        return null;
      }
    };

    const clearStoredFormKind = () => {
      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (error) {
      }
    };

    sections.forEach((section) => {
      const sectionId = section.getAttribute('data-rv-auction-section-id');
      const dialog = section.querySelector('[data-rv-auction-dialog]');
      const openButton = section.querySelector('[data-rv-auction-open]');
      const closeButton = section.querySelector('[data-rv-auction-close]');
      const forms = section.querySelectorAll('.rv-auction-form');
      let restoreFocusTarget = null;
      let closeTimer = null;

      const clearCloseTimer = () => {
        if (!closeTimer) {
          return;
        }
        window.clearTimeout(closeTimer);
        closeTimer = null;
      };

      const scrollToSection = () => {
        const header = document.querySelector('.rv-header');
        const offset = header ? header.getBoundingClientRect().height + 12 : 96;
        const targetTop = section.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: targetTop, behavior: reduceMotionQuery.matches ? 'auto' : 'smooth' });
      };

      const scrollToTarget = (targetId, behavior) => {
        if (!targetId) {
          return;
        }
        const target = document.getElementById(targetId);
        if (!target) {
          return;
        }
        const header = document.querySelector('.rv-header');
        const offset = header ? header.getBoundingClientRect().height : 87;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: targetTop, behavior });
      };

      const finishDialogClose = () => {
        if (!dialog) {
          return;
        }
        clearCloseTimer();
        dialog.classList.remove('is-open');
        document.body.classList.remove('rv-auction-inquiry-open');
        if (dialog.open) {
          dialog.close();
        }
        if (openButton) {
          openButton.setAttribute('aria-expanded', 'false');
        }
        if (restoreFocusTarget) {
          restoreFocusTarget.focus();
          restoreFocusTarget = null;
        }
      };

      const closeDialog = () => {
        if (!dialog || !dialog.open) {
          return;
        }
        clearCloseTimer();
        dialog.classList.remove('is-open');
        document.body.classList.remove('rv-auction-inquiry-open');
        if (openButton) {
          openButton.setAttribute('aria-expanded', 'false');
        }
        if (reduceMotionQuery.matches) {
          finishDialogClose();
          return;
        }
        closeTimer = window.setTimeout(() => {
          finishDialogClose();
        }, 220);
      };

      const openDialog = (focusTarget) => {
        if (!dialog) {
          return;
        }
        clearCloseTimer();
        if (!dialog.open) {
          dialog.show();
        }
        restoreFocusTarget = focusTarget || openButton;
        document.body.classList.add('rv-auction-inquiry-open');
        if (openButton) {
          openButton.setAttribute('aria-expanded', 'true');
        }
        window.requestAnimationFrame(() => {
          dialog.classList.add('is-open');
        });
      };

      forms.forEach((form) => {
        form.addEventListener('submit', () => {
          const box = form.closest('[data-rv-auction-box]');
          const kind = box ? box.getAttribute('data-rv-auction-box') : null;
          if (!kind || !sectionId) {
            return;
          }
          setStoredFormKind(sectionId, kind);
        });
      });

      if (openButton) {
        openButton.addEventListener('click', () => {
          openDialog(openButton);
        });
      }

      window.addEventListener('rv:auction-inquiry-open', () => {
        openDialog(openButton);
      });

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          closeDialog();
        });
      }

      if (dialog) {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) {
            closeDialog();
          }
        });

        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeDialog();
        });

        dialog.addEventListener('close', () => {
          clearCloseTimer();
          dialog.classList.remove('is-open');
          document.body.classList.remove('rv-auction-inquiry-open');
          if (openButton) {
            openButton.setAttribute('aria-expanded', 'false');
          }
        });
      }

      const storedState = getStoredFormKind();
      if (!storedState || storedState.sectionId !== sectionId) {
        if (window.location.hash == '#auction-inquiry') {
          window.requestAnimationFrame(() => {
            scrollToTarget('auction-inquiry', 'auto');
            openDialog(openButton);
          });
        }
        return;
      }

      const activeBox = section.querySelector(`[data-rv-auction-box="${storedState.kind}"]`);
      if (!activeBox) {
        clearStoredFormKind();
        return;
      }

      const successMessage = activeBox.querySelector('[data-rv-auction-feedback="success"][data-liquid-state="true"]');
      const errorMessage = activeBox.querySelector('[data-rv-auction-feedback="error"][data-liquid-state="true"]');

      if (successMessage) {
        activeBox.classList.add('is-success');
        if (storedState.kind === 'inquiry') {
          openDialog(openButton);
        } else {
          scrollToSection();
        }
        window.requestAnimationFrame(() => {
          successMessage.focus();
        });
      } else if (errorMessage) {
        activeBox.classList.add('is-error');
        if (storedState.kind === 'inquiry') {
          openDialog(openButton);
        } else {
          scrollToSection();
        }
        window.requestAnimationFrame(() => {
          errorMessage.focus();
        });
      }

      clearStoredFormKind();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-information"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.rv-event-information[data-rv-reveal]');
    if (!sections.length) {
      return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const animateAccordion = (details, isOpening) => {
      const summary = details.querySelector('.rv-event-information__summary');
      if (!summary) {
        details.open = isOpening;
        return;
      }

      if (details.dataset.animating === 'true') {
        return;
      }

      if (isOpening) {
        details.classList.remove('is-closing');
      } else {
        details.classList.add('is-closing');
      }

      details.dataset.animating = 'true';
      const startHeight = details.offsetHeight;
      if (isOpening) {
        details.open = true;
      }
      const endHeight = isOpening ? details.offsetHeight : summary.offsetHeight;

      details.style.overflow = 'hidden';
      details.style.height = `${startHeight}px`;

      const animation = details.animate(
        [
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ],
        {
          duration: isOpening ? 320 : 260,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)'
        }
      );

      animation.onfinish = () => {
        if (!isOpening) {
          details.open = false;
        }
        details.classList.remove('is-closing');
        details.style.height = '';
        details.style.overflow = '';
        details.dataset.animating = 'false';
      };

      animation.oncancel = () => {
        details.classList.remove('is-closing');
        details.style.height = '';
        details.style.overflow = '';
        details.dataset.animating = 'false';
      };
    };

    sections.forEach((section) => {
      const items = section.querySelectorAll('details.rv-event-information__item');
      items.forEach((item, index) => {
        item.style.setProperty('--rv-event-delay', `${160 + index * 110}ms`);

        const summary = item.querySelector('.rv-event-information__summary');
        if (!summary) {
          return;
        }

        summary.addEventListener('click', (event) => {
          if (reduceMotion) {
            return;
          }
          event.preventDefault();
          animateAccordion(item, !item.open);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }
      const link = event.target.closest('[data-rv-auction-inquiry-link]');
      if (!link) {
        return;
      }
      const href = (link.getAttribute('href') || '').trim();
      if (!href || href[0] != '#') {
        return;
      }
      event.preventDefault();
      window.history.replaceState(null, '', href);
      window.dispatchEvent(new CustomEvent('rv:auction-inquiry-open'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const headerRoot = document.querySelector('.rv-header');
    const railRoot = document.querySelector('.rv-header-rail');
    const railThemeSections = Array.from(document.querySelectorAll('[data-rv-header-rail-theme]'));
    const isHomePage = headerRoot && headerRoot.dataset.isHome == 'true';
    const desktopToggle = document.querySelector('[data-desktop-toggle]');
    const desktopMenu = document.getElementById('rv-header-desktop-nav');
    const mobileOpenButton = document.querySelector('[data-mobile-open]');
    const mobileDialog = document.getElementById('rv-header-menu');
    const desktopMedia = window.matchMedia('(min-width: 768px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileCloseAnimationMs = 180;
    const mobileOffsetOverlapPx = 2;
    const scrollDeltaThreshold = 8;
    const topRevealThreshold = 8;
    let mobileTrigger = null;
    let isMobileClosing = false;
    let mobileCloseTimer = null;
    let lastScrollY = Math.max(window.scrollY, 0);
    let scrollDirection = 'none';
    let directionDistance = 0;
    let ticking = false;

    const buildRailMask = (intervals, railHeight) => {
      if (!intervals.length || railHeight <= 0) {
        return 'linear-gradient(to bottom, transparent 0px, transparent 100%)';
      }

      const maskStops = ['transparent 0px'];
      let cursor = 0;

      intervals.forEach(([start, end]) => {
        const safeStart = Math.max(start, cursor, 0);
        const safeEnd = Math.min(Math.max(end, safeStart), railHeight);
        if (safeStart > cursor) {
          maskStops.push(`transparent ${safeStart}px`);
        }
        maskStops.push(`#000 ${safeStart}px`);
        maskStops.push(`#000 ${safeEnd}px`);
        cursor = safeEnd;
        if (cursor < railHeight) {
          maskStops.push(`transparent ${cursor}px`);
        }
      });

      if (cursor < railHeight) {
        maskStops.push(`transparent ${railHeight}px`);
      }

      return `linear-gradient(to bottom, ${maskStops.join(', ')})`;
    };

    const syncRailTheme = () => {
      if (!railRoot) {
        return;
      }

      if (!isHomePage || !railThemeSections.length) {
        railRoot.style.setProperty('--rv-header-rail-blue-mask', 'linear-gradient(to bottom, transparent 0px, transparent 100%)');
        return;
      }

      const railRect = railRoot.getBoundingClientRect();
      const railHeight = Math.round(railRect.height);
      if (railHeight <= 0) {
        return;
      }

      const blueIntervals = [];
      railThemeSections.forEach((section) => {
        if (section.getAttribute('data-rv-header-rail-theme') != 'blue') {
          return;
        }
        const sectionRect = section.getBoundingClientRect();
        const start = Math.max(sectionRect.top, railRect.top);
        const end = Math.min(sectionRect.bottom, railRect.bottom);
        if (end <= start) {
          return;
        }
        blueIntervals.push([
          Math.round(start - railRect.top),
          Math.round(end - railRect.top)
        ]);
      });

      blueIntervals.sort((intervalA, intervalB) => intervalA[0] - intervalB[0]);
      const mergedIntervals = [];
      blueIntervals.forEach((interval) => {
        if (!mergedIntervals.length) {
          mergedIntervals.push(interval);
          return;
        }
        const previousInterval = mergedIntervals[mergedIntervals.length - 1];
        if (interval[0] <= previousInterval[1]) {
          previousInterval[1] = Math.max(previousInterval[1], interval[1]);
          return;
        }
        mergedIntervals.push(interval);
      });

      railRoot.style.setProperty('--rv-header-rail-blue-mask', buildRailMask(mergedIntervals, railHeight));
    };

    const setHeaderScrollVisibility = (hidden) => {
      if (!headerRoot) {
        return;
      }
      headerRoot.classList.toggle('is-scroll-hidden', hidden);
      headerRoot.classList.toggle('is-scroll-visible', !hidden);
    };

    const isDesktopMenuOpen = () => {
      if (!headerRoot) {
        return false;
      }
      return headerRoot.classList.contains('is-desktop-menu-open');
    };

    const evaluateHeaderScrollState = () => {
      if (!headerRoot) {
        return;
      }

      const currentScrollY = Math.max(window.scrollY, 0);
      const deltaY = currentScrollY - lastScrollY;
      const absDeltaY = Math.abs(deltaY);
      const isMobileMenuOpen = document.body.classList.contains('rv-mobile-menu-open');

      if (currentScrollY <= topRevealThreshold || isMobileMenuOpen || isDesktopMenuOpen()) {
        setHeaderScrollVisibility(false);
        lastScrollY = currentScrollY;
        scrollDirection = 'none';
        directionDistance = 0;
        return;
      }

      if (absDeltaY < 1) {
        return;
      }

      const nextDirection = deltaY > 0 ? 'down' : 'up';
      if (nextDirection != scrollDirection) {
        scrollDirection = nextDirection;
        directionDistance = 0;
      }
      directionDistance += absDeltaY;

      if (directionDistance >= scrollDeltaThreshold) {
        if (scrollDirection == 'down') {
          setHeaderScrollVisibility(true);
        } else {
          setHeaderScrollVisibility(false);
        }
        directionDistance = 0;
      }

      lastScrollY = currentScrollY;
    };

    const requestScrollEvaluation = () => {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(() => {
        evaluateHeaderScrollState();
        syncRailTheme();
        ticking = false;
      });
    };

    const clearMobileCloseTimer = () => {
      if (mobileCloseTimer) {
        window.clearTimeout(mobileCloseTimer);
        mobileCloseTimer = null;
      }
    };

    const getHeaderHeight = () => {
      if (!headerRoot) {
        return 0;
      }
      return Math.round(headerRoot.getBoundingClientRect().height);
    };

    const syncHeaderSpacerHeight = () => {
      const headerHeight = getHeaderHeight();
      if (headerHeight <= 0) {
        return;
      }
      document.documentElement.style.setProperty('--rv-header-spacer-height', `${headerHeight}px`);
    };

    const syncMobileMenuOffset = () => {
      if (!mobileDialog) {
        return;
      }
      const headerHeight = getHeaderHeight();
      const offset = Math.max(0, headerHeight - mobileOffsetOverlapPx);
      syncHeaderSpacerHeight();
      mobileDialog.style.setProperty('--rv-header-mobile-offset', `${offset}px`);
    };

    const scrollToAnchorTarget = (anchorId, behavior) => {
      if (!anchorId) {
        return;
      }
      const targetElement = document.getElementById(anchorId);
      if (!targetElement) {
        return;
      }
      const headerHeight = getHeaderHeight();
      const destination = Math.max(0, Math.round(targetElement.getBoundingClientRect().top + window.scrollY - headerHeight));
      window.scrollTo({
        top: destination,
        behavior
      });
      window.history.replaceState(null, '', `#${anchorId}`);
    };

    const handleTopPageAnchorNavigation = (link) => {
      if (!link) {
        return false;
      }
      const href = (link.getAttribute('href') || '').trim();
      if (!href) {
        return false;
      }
      if (href[0] != '#') {
        return false;
      }
      const anchorId = link.getAttribute('data-rv-anchor');
      if (!anchorId) {
        return false;
      }

      if (link.closest('#rv-header-desktop-nav')) {
        setDesktopOpen(false);
      }
      if (link.closest('#rv-header-menu')) {
        mobileTrigger = null;
        closeMobileMenu();
      }

      const behavior = reduceMotionQuery.matches ? 'auto' : 'smooth';
      window.requestAnimationFrame(() => {
        scrollToAnchorTarget(anchorId, behavior);
      });
      return true;
    };

    const setDesktopOpen = (open) => {
      if (!desktopToggle || !desktopMenu || !headerRoot) {
        return;
      }
      headerRoot.classList.toggle('is-desktop-menu-open', open);
      desktopToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      desktopToggle.textContent = open ? 'CLOSE [ x ]' : 'MENU [ + ]';
      setHeaderScrollVisibility(false);
      evaluateHeaderScrollState();
    };

    const syncMobileButton = (open) => {
      if (!mobileOpenButton || !mobileDialog) {
        return;
      }
      mobileOpenButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileOpenButton.textContent = open ? 'CLOSE [ x ]' : 'MENU [ + ]';
    };

    const finishMobileClose = () => {
      if (!mobileDialog) {
        return;
      }
      clearMobileCloseTimer();
      isMobileClosing = false;
      mobileDialog.classList.remove('is-mobile-menu-closing');
      mobileDialog.classList.remove('is-mobile-menu-open');
      document.body.classList.remove('rv-mobile-menu-open');
      if (mobileDialog.open) {
        mobileDialog.close();
      }
      syncMobileButton(false);
      if (mobileTrigger) {
        mobileTrigger.focus();
      }
      evaluateHeaderScrollState();
    };

    const closeMobileMenu = () => {
      if (!mobileDialog || !mobileOpenButton) {
        return;
      }
      if (!mobileDialog.open || isMobileClosing) {
        return;
      }
      clearMobileCloseTimer();
      isMobileClosing = true;
      mobileDialog.classList.remove('is-mobile-menu-open');
      mobileDialog.classList.add('is-mobile-menu-closing');
      syncMobileButton(false);
      if (reduceMotionQuery.matches) {
        finishMobileClose();
        return;
      }
      mobileCloseTimer = window.setTimeout(() => {
        finishMobileClose();
      }, mobileCloseAnimationMs);
    };

    const openMobileMenu = () => {
      if (!mobileDialog || !mobileOpenButton || isMobileClosing) {
        return;
      }
      clearMobileCloseTimer();
      if (!mobileDialog.open) {
        mobileDialog.show();
      }
      document.body.classList.add('rv-mobile-menu-open');
      mobileDialog.classList.remove('is-mobile-menu-closing');
      setHeaderScrollVisibility(false);
      window.requestAnimationFrame(() => {
        mobileDialog.classList.add('is-mobile-menu-open');
      });
      syncMobileButton(true);
    };

    const resetMobileMenu = () => {
      if (!mobileDialog) {
        return;
      }
      clearMobileCloseTimer();
      isMobileClosing = false;
      mobileDialog.classList.remove('is-mobile-menu-closing');
      mobileDialog.classList.remove('is-mobile-menu-open');
      document.body.classList.remove('rv-mobile-menu-open');
      if (mobileDialog.open) {
        mobileDialog.close();
      }
      syncMobileButton(false);
    };

    setDesktopOpen(false);
    resetMobileMenu();
    syncMobileMenuOffset();
    setHeaderScrollVisibility(false);
    evaluateHeaderScrollState();
    syncRailTheme();

    if (isHomePage && window.location.hash.length > 1) {
      const hashAnchorId = window.location.hash.slice(1);
      window.requestAnimationFrame(() => {
        scrollToAnchorTarget(hashAnchorId, 'auto');
      });
    }

    if (desktopToggle && desktopMenu) {
      desktopToggle.addEventListener('click', () => {
        if (!desktopMedia.matches) {
          return;
        }
        const open = desktopToggle.getAttribute('aria-expanded') == 'true';
        setDesktopOpen(!open);
      });
    }

    if (mobileOpenButton && mobileDialog) {
      mobileOpenButton.addEventListener('click', () => {
        if (desktopMedia.matches) {
          return;
        }
        mobileTrigger = mobileOpenButton;
        const open = mobileOpenButton.getAttribute('aria-expanded') == 'true';
        if (open) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });

      mobileDialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeMobileMenu();
      });

      mobileDialog.addEventListener('close', () => {
        clearMobileCloseTimer();
        isMobileClosing = false;
        mobileDialog.classList.remove('is-mobile-menu-closing');
        mobileDialog.classList.remove('is-mobile-menu-open');
        document.body.classList.remove('rv-mobile-menu-open');
        syncMobileButton(false);
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key != 'Escape') {
        return;
      }
      if (desktopMedia.matches) {
        const open = desktopToggle && desktopToggle.getAttribute('aria-expanded') == 'true';
        if (open) {
          setDesktopOpen(false);
          desktopToggle.focus();
        }
        return;
      }
      const open = mobileOpenButton && mobileOpenButton.getAttribute('aria-expanded') == 'true';
      if (open) {
        closeMobileMenu();
      }
    });

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }
      const clickedLink = event.target.closest('[data-rv-anchor]');
      if (!clickedLink) {
        return;
      }
      const didHandle = handleTopPageAnchorNavigation(clickedLink);
      if (didHandle) {
        event.preventDefault();
      }
    });

    desktopMedia.addEventListener('change', () => {
      setDesktopOpen(false);
      resetMobileMenu();
      syncMobileMenuOffset();
      evaluateHeaderScrollState();
      syncRailTheme();
    });

    window.addEventListener('resize', () => {
      syncMobileMenuOffset();
      evaluateHeaderScrollState();
      syncRailTheme();
    });

    window.addEventListener('scroll', () => {
      requestScrollEvaluation();
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const section = document.querySelector('.rv-product');
    if (!section) {
      return;
    }

    const mediaTrack = section.querySelector('[data-rv-media-track]');
    const mediaItems = section.querySelectorAll('[data-rv-media-item]');
    const thumbs = section.querySelectorAll('[data-rv-thumb]');
    const prevButton = section.querySelector('[data-rv-carousel-prev]');
    const nextButton = section.querySelector('[data-rv-carousel-next]');

    const setActiveThumb = (targetId) => {
      thumbs.forEach((thumb) => {
        if (thumb.dataset.target === targetId) {
          thumb.classList.add('is-active');
        } else {
          thumb.classList.remove('is-active');
        }
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = section.querySelector(`#${thumb.dataset.target}`);
        if (!target) {
          return;
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        setActiveThumb(thumb.dataset.target);
      });
    });

    const updateCarouselButtons = () => {
      if (!mediaTrack || !prevButton || !nextButton) {
        return;
      }

      const maxScrollLeft = mediaTrack.scrollWidth - mediaTrack.clientWidth;
      prevButton.disabled = mediaTrack.scrollLeft <= 8;
      nextButton.disabled = mediaTrack.scrollLeft >= maxScrollLeft - 8;
    };

    if (mediaTrack && prevButton && nextButton) {
      prevButton.addEventListener('click', () => {
        mediaTrack.scrollBy({ left: -mediaTrack.clientWidth, behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        mediaTrack.scrollBy({ left: mediaTrack.clientWidth, behavior: 'smooth' });
      });

      mediaTrack.addEventListener('scroll', updateCarouselButtons, { passive: true });
      window.addEventListener('resize', updateCarouselButtons);
      updateCarouselButtons();
    }

    if (mediaTrack && mediaItems.length > 0 && window.matchMedia('(min-width: 990px)').matches) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActiveThumb(entry.target.id);
            }
          });
        },
        {
          root: null,
          threshold: 0.55,
        }
      );

      mediaItems.forEach((item) => observer.observe(item));
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
